import { render, staticRenderFns } from "./FiscalNatureSetting.vue?vue&type=template&id=f6dc8bae"
import script from "./FiscalNatureSetting.vue?vue&type=script&lang=js"
export * from "./FiscalNatureSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports